<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label>Descrição</label>
        <input
          type="text"
          class="form-control"
          v-model="description"
          ref="autofocus"
        />
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" @click="create" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "Create",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      description: "",
      loading: false,
      errors: [],
    };
  },
  created() {
    setTimeout(() => this.$refs.autofocus.focus(), 200);
  },
  methods: {
    async create() {
      try {
        this.loading = true;

        const { description } = this;

        let params = { description };

        const response = await api.post(
          "/rest-home/financial/configuration/payment-methods",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide("create");

          this.$emit("success");

          this.description = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
